import organization_menu_list from './menu-list';
import organization_menu_add from './menu-add';
import organization_menu_edit from './menu-edit';
import organization_menu_detail from './menu-detail';

export default {
    organization_menu_list,
    organization_menu_add,
    organization_menu_edit,
    organization_menu_detail,
};
